const config = {
    dev: {
        API_BASE_URL: 'http://localhost:8000'
    },
    prod: {
        API_BASE_URL: 'https://api.lovesano.it'
    }
};

export default config[process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'dev'];